module.exports = __webpack_public_path__ + "img/meteor.cfa3725b.svg";